<template>
  <div class="menu">
    <div class="menu-content">
      <div class="close" @click.stop="close">
        <ag-icon width="32" height="32" color="white">
          <x-icon />
        </ag-icon>
      </div>
      <div class="menu-items">
        <menu-item label="Recipes" @click="routeTo('Recipes')">
          <ag-icon>
            <book-open-icon />
          </ag-icon>
        </menu-item>
        <menu-item v-if="isAuthenticated" label="Add New Recipe" @click="routeToAdd">
          <ag-icon>
            <file-plus-icon />
          </ag-icon>
        </menu-item>
      </div>
      <div class="menu-footer">
        <ag-button v-if="!isAuthenticated" priority="subtle" @click="routeTo('Login')">
          <ag-icon color="#b13fa3">
            <profile-icon />
          </ag-icon>
          <span>Log in</span>
        </ag-button>
        <ag-button v-else priority="subtle" @click="logout">
          <ag-icon color="#b13fa3">
            <profile-icon />
          </ag-icon>
          <span>Log out</span>
        </ag-button>

      </div>
    </div>
    <div class="overlay" @click.stop="close"></div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import XIcon from "./icons/XIcon";
  import MenuItem from "./MenuItem";
  import { BookOpenIcon, FilePlusIcon } from "vue-feather-icons";
  import ProfileIcon from "./icons/ProfileIcon";

  export default {
    name: "Menu",
    computed: {
      ...mapState("user", ["isAuthenticated"])
    },
    methods: {
      close() {
        this.$emit("close");
      },
      logout() {
        this.$store.dispatch(this.$action.USER.LOGOUT);
        this.routeTo("Recipes");
      },
      routeTo(route) {
        this.$router.currentRoute.name !== route &&
          this.$router.push({ name: route });

        this.close();
      },
      routeToAdd() {
        this.$router.push({
          name: "RecipeNew",
          params: { categoryKey: "new" }
        });

        this.close();
      }
    },
    components: {
      BookOpenIcon,
      FilePlusIcon,
      ProfileIcon,
      MenuItem,
      XIcon
    }
  };
</script>

<style scoped lang="scss">
  .menu {
    position: fixed;
    z-index: 1000;
    top: 0;
    bottom: 0;
    left: -100%;
    width: 100%;
    display: flex;
    box-shadow: 0 2px 24px rgba(0, 0, 0, 0.06);

    &.active {
      left: 0;

      .menu-content {
        left: 0;
      }

      .overlay {
        opacity: 0.3;
      }
    }

    .menu-content {
      position: fixed;
      z-index: 1001;
      top: 0;
      bottom: 0;
      left: -100%;
      width: calc(100% - 12px);
      max-width: 600px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: rgba($color-primary,0.97);
      box-shadow: 0 0 24px rgba(0, 0, 0, 0.3);
      transition: $transition;

      .close {
        position: absolute;
        top: 4px;
        right: 4px;
        cursor: pointer;
        border-radius: $radius;
        padding: 12px;

        svg {
          display: block;
        }

        &:hover {
          background: rgba(0, 0, 0, 0.25);
        }
      }

      // TODO - Needs to scroll
      .menu-items {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        flex-grow: 1;
        margin: 0 auto;

        svg {
          stroke: $color-secondary;
        }
      }

      .menu-footer {
        padding: 12px $gutter;
        border-top: 1px solid rgba($color-secondary, 0.3);
        background: rgba(0,0,0,0.15);

        button {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(255,255,255,0.7);
          font-size: 14px;
          
          svg {
            margin-right: 8px;
          }

          &:hover {
            color: $color-white;
          }
        }
      }
    }

    .overlay {
      flex-grow: 1;
      background: black;
      opacity: 0;
      transition: all 0.4s ease-in-out;
    }
  }
</style>
